import { useLocale } from "next-intl";
import { signOut } from "@/api/authNew";
import { appConfig } from "@/config/app";
import { useRouter } from "@/i18n/routing";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { publishSessionLogout, generateTabId } from "@/utils/sessionLogout";
import { clearClientUserState } from "@/utils/clearClientUserState";

export function useSignOut() {
  const router = useRouter();
  const locale = useLocale();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: signOut,
    onSuccess() {
      // Notify sibling tabs in this browser that the session has ended
      // so they can drop their local auth state immediately, without
      // waiting for their next API call to 401. Origin id is unique per
      // call -> sibling tabs always treat this as external (we are about
      // to navigate away anyway, so our own echo does not matter here).
      publishSessionLogout({
        reason: "user_logout",
        origin: generateTabId(),
        now: new Date(),
      });

      clearClientUserState(queryClient);
      router.replace(appConfig.unauthenticatedEntry, { locale });
      router.refresh();
    },
  });
}
